import styled from 'styled-components'

const TrackDetail = styled.div`
    flex: 1;
    
    > p{
      color: #33333a;
      font-size: 14px;
    }
`;


const TrackBox = styled.div`  
    padding: 20px 16px;
    border-radius: 13px;
    background: #d8d8d833;
    min-height: 215px;
    padding: 94px 16px;
  > p {
    display: flex;
    justify-content: space-between;
    color: #00b3ff;
    text-transform: uppercase;
    font-size: 12px;
        font-family: "latobold";

    > span {
      cursor: pointer;
    }
  }

`
const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
  flex-direction: column;
  svg {
      margin: 0 auto;
          z-index: 1;
    background: #f7f7f7;
    }
     :before {
      content: '';
      display: inline-block;
      height: 2px;
      width: 100%;
      background-color: #979797;
      position: relative;
      right: -49%;
      top: 50%;
      z-index: 0;
    } 
`
const Heading = styled.div`
  font-size: 20px;
  color: #000000;
  line-height: 25px;
  font-family: 'latobold';
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  Button {
    color: #00b3ff;
    background: #ffffff;
    font-size: 20px;
  }
`;
const TrackDescription = styled.div`
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    align-items: flex-start;
    .active {
      > div::before {
background-color: #00b3ff;
      }
    }
    > div {
          display: grid;
    text-align: center;
    flex:1;
      :last-child {
        ${Icon} {
          :before {
          background-color: transparent;
    }
        }
      }
      h3 {
        color: #33333a;
        font-size: 14px;
        text-transform: uppercase;
        font-family: "latobold";
            margin: 10px 0 8px 0;
      }
      > div {
        > p {
        font-size: 12px;
        margin: 0; 
      }
      }
      
    }
`
const Panding = styled.p`
        color: #ff7d00;
          text-transform: uppercase;`

const DeliveredSection = styled.div`
  > div {
    font-weight: bold;
  }
  textarea {
    width: 100%;
    border: solid 1px #eaeaea;
    padding:5px;
  }
  > p {
    width: fit-content;
  }
`
const RatingSection = styled.div`
  font-family: "latoregular";
display: flex;
    gap: 10px;
    align-items: center;
    .MuiBox-root {
      margin-bottom: 0;
    }
`
const ReviewSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
      font-family: "latoregular";

    button {
        align-self: flex-end;
        margin-top: 10px;
    }
`
const Msg = styled.div`
  text-align: center;
  font-size: 18px;
  color:blue;
`
export { TrackDetail, TrackBox, TrackDescription, Heading, Panding, Icon, DeliveredSection, RatingSection, ReviewSection, Msg };